<div class="dashboard">
  <div *ngIf="loading" class="loading-overlay">
    <div class="loading-spinner"></div>
    <div class="loading-text">Loading dashboard data...</div>
  </div>
  
  <div *ngIf="error" class="error-message">
    <div class="main">
      <div id="metrics" class="metrics-grid">
        <div class="metric-card" *ngFor="let stat of statsCards">
          <div class="icon-wrapper" [style.background-color]="stat.bg">
            <img [src]="stat.icon" alt="{{ stat.label }} Icon" />
          </div>
          <span class="metric-value">{{ stat.number }}</span>
          <span class="metric-label">{{ stat.label }}</span>
        </div>
      </div>
    </div>
    <div class="main-content">
      <div class="projects-section">
        
        <nav class="tabs">
          <button class="tab" [class.active]="activeTab === 'invited'" (click)="setActiveTab('invited')">Invited</button>
          <button class="tab" [class.active]="activeTab === 'assigned'" (click)="setActiveTab('assigned')">Assigned</button>
          <button class="tab" [class.active]="activeTab === 'all'" (click)="setActiveTab('all')">All Projects</button>
          <button class="tab" [class.active]="activeTab === 'completed'" (click)="setActiveTab('completed')">Completed</button>
        </nav>
        <div *ngIf="activeTab === 'invited' && visibilityVendor" class="tab-content" style="text-align: center;">No invited projects found</div>
        <div *ngIf="activeTab === 'assigned' && visibilityVendor" class="tab-content" style="text-align: center;">No assinged projects found</div>
        <div *ngIf="activeTab === 'all' && visibilityVendor" class="tab-content" style="text-align: center;">No projects found</div>
        <div *ngIf="activeTab === 'completed' && visibilityVendor" class="tab-content" style="text-align: center;">No projects found</div>
      </div>
    </div>
  </div>

  <div *ngIf="!loading && !error" class="dashboard-content">
    <div class="main">
      <div id="metrics" class="metrics-grid">
        <div class="metric-card" *ngFor="let stat of statsCards">
          <div class="icon-wrapper" [style.background-color]="stat.bg">
            <img [src]="stat.icon" alt="{{ stat.label }} Icon" />
          </div>
          <span class="metric-value">{{ stat.number }}</span>
          <span class="metric-label">{{ stat.label }}</span>
        </div>
      </div>
    </div>

    <div class="main-content">
      <div class="projects-section">
        <div class="projects-toolbar">
          <div class="search-box">
            <img src="../../../assets/images/svgs/images/1_74.svg" class="search-icon">
            <input type="text" class="search-input" placeholder="Search projects..." [(ngModel)]="searchQuery" (input)="onSearch()">
          </div>
        </div>
        
        <nav class="tabs">
          <button class="tab" [class.active]="activeTab === 'invited'" (click)="setActiveTab('invited')">Invited</button>
          <button class="tab" [class.active]="activeTab === 'assigned'" (click)="setActiveTab('assigned')">Assigned</button>
          <button class="tab" [class.active]="activeTab === 'all'" (click)="setActiveTab('all')">All Projects</button>
          <button class="tab" [class.active]="activeTab === 'completed'" (click)="setActiveTab('completed')">Completed</button>
        </nav>

        <!-- Invited Projects Tab -->
        <div *ngIf="activeTab === 'invited' && visibilityVendor" class="tab-content">
          <div class="projects-grid-container">
            <div class="projects-grid-header">
              <div>Project Details</div>
              <div>Status</div>
              <div>Owner</div>
              <div>Actions</div>
            </div>
            
            <div class="projects-grid-body">
              <div *ngFor="let project of filteredInvitedProjects" class="project-card">
                <div class="grid-cell">
                  <div class="project-details">
                    <div class="project-meta">
                      <span class="date" [style.color]="getDateColor(project.createdDate)">
                        Posted:{{ getFormattedDate(project.createdDate) }}
                      </span>
                      <span class="lead">{{ project.lead.toLowerCase().includes('sales') ? 'sales' : project.lead }}</span>
                    </div>
                    <div class="customer">{{ project.customer }}</div>
                    <div class="type">{{ project.type }}</div>
                    <div class="project-title">
                      <span class="title">{{ project.title }}</span>
                      <span *ngIf="project.revisionRequested" class="rebid-tag"
                            [title]="project.revisedBudget ? 'Revised budget: ₹' + project.revisedBudget.toLocaleString('en-IN') : 'Budget revised — please update your bid'">
                        <i-tabler name="refresh-alert" style="width:12px;height:12px;flex-shrink:0;"></i-tabler>
                        Re-bid Required
                      </span>
                    </div>
                  </div>
                </div>

                <div class="grid-cell">
                  <div class="project-status">
                    <div *ngIf="project.status == 'In Progress'" class="status-icons">
                      <i *ngIf="project.stgplan" title="Waiting for Terms of Engagement to be Accepted."
                         class="bi bi-bullseye status-icon planning"></i>
                      <i *ngIf="project.stgres" title="Looking for Vendors."
                         class="bi bi-people status-icon resources"></i>
                      <i *ngIf="project.stgdel" title="Delivering."
                         class="bi bi-truck status-icon delivery"></i>
                    </div>
                  </div>
                </div>

                <div class="grid-cell">
                  <div class="project-owner">{{ project.owner }}</div>
                </div>

                <div class="grid-cell">
                  <div class="project-actions">
                    <button class="action-btn" [disabled]="!project.deliveryDate"
                            [title]="project.deliveryDate ? 'Delivery Information: ' + project.deliveryDate : 'No Delivery Date Available'">
                      <i-tabler name="calendar" [style.color]="project.deliveryDate ? '#ec202a' : '#888888'"></i-tabler>
                    </button>
                    <a href="/workspace/project/{{ project.id }}" target="_blank" class="action-btn-link">
                      <button class="action-btn" [class.rebid-action]="project.revisionRequested"
                              [title]="project.revisionRequested ? 'Update Bid' : 'View ' + project.id">
                        <i-tabler [name]="project.revisionRequested ? 'refresh-alert' : 'arrow-up-right'"
                                  [style.color]="project.revisionRequested ? '#B45309' : '#ec202a'"></i-tabler>
                      </button>
                    </a>
                  </div>
                </div>
              </div>

              <div *ngIf="invitedProjects.length === 0" class="no-projects-card">
                No invited projects found
              </div>
            </div>
          </div>
        </div>

        <!-- Assigned Projects Tab -->
        <div *ngIf="activeTab === 'assigned' && visibilityVendor" class="tab-content">
          <div class="projects-grid-container">
            <div class="projects-grid-header">
               <div>Project Details</div>
              <div>Status</div>
              <div>Owner</div>
              <div>Actions</div>
            </div>
            
            <div class="projects-grid-body">
              <div *ngFor="let project of filteredAssignedProjects" class="project-card">
                <div class="grid-cell">
                  <div class="project-details">
                    <div class="project-meta">
                      <span class="date" [style.color]="getDateColor(project.createdDate)">
                         Posted:{{ getFormattedDate(project.createdDate) }}
                      </span>
                      <!-- <span class="customer">- {{ project.customer }}</span>
                      <span class="type">- {{ project.type }}</span> -->
                      <span class="lead">{{ project.lead.toLowerCase().includes('sales') ? 'sales' : project.lead }}</span>
                    </div>
                    <div class="customer">{{ project.customer }}</div>
                    <div class="type">{{ project.type }}</div>
                    <div class="project-title">
                      <span class="title">{{ project.title }}</span>
                      <!-- <span class="vendor-stars">
                        <i *ngFor="let star of [].constructor(getVendorCostStars(project.vendorCost)); let i = index" 
                           class="bi bi-star-fill" style="color: gold; margin: 0 2px"></i>
                      </span> -->
                    </div>
                  </div>
                </div>
                
                <div class="grid-cell">
                  <div class="project-status">
                    <div *ngIf="project.status == 'In Progress'" class="status-icons">
                      <i *ngIf="project.stgplan" title="Waiting for Terms of Engagement to be Accepted." 
                         class="bi bi-bullseye status-icon planning"></i>
                      <i *ngIf="project.stgres" title="Looking for Vendors." 
                         class="bi bi-people status-icon resources"></i>
                      <i *ngIf="project.stgdel" title="Delivering." 
                         class="bi bi-truck status-icon delivery"></i>
                    </div>
                  </div>
                </div>
                
                <div class="grid-cell">
                  <div class="project-owner">
                    {{ project.owner }}
                  </div>
                </div>
                
                <div class="grid-cell">
                  <div class="project-actions">
                    <button class="action-btn" [disabled]="!project.deliveryDate" 
                            [title]="project.deliveryDate ? 'Delivery Information: ' + project.deliveryDate : 'No Delivery Date Available'">
                      <i-tabler name="calendar" [style.color]="project.deliveryDate ? '#ec202a' : '#888888'"></i-tabler>
                    </button>
                    <a href="/workspace/project/{{ project.id }}" target="_blank" class="action-btn-link">
                      <button class="action-btn" title="View {{ project.id }}">
                        <i-tabler name="arrow-up-right" style="color: #ec202a"></i-tabler>
                      </button>
                    </a>
                  </div>
                </div>
              </div>
              
              <div *ngIf="assignedProjects.length === 0" class="no-projects-card">
                No assigned projects found
              </div>
            </div>
          </div>
        </div>

        <!-- All Projects Tab -->
        <div *ngIf="activeTab === 'all'" class="tab-content">
          <div class="table-responsive-wrapper">
            <table class="projects-table">
              <thead>
                <tr>
                  <th>Project Name</th>
                  <th>Status</th>
                  <th>Bid Amount</th>
                  <th>Timeline</th>
                  <th>Progress</th>
                  <th>Client Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let project of filteredAllProjects" 
                    [routerLink]="['/workspace/project', slugify(project.name)]" 
                    class="clickable-row">
                  <td>
                    <div class="cell-with-icon">
                      <!-- <span>{{ project.name }}</span> -->
                       <span>{{ project.title || project.name }}</span>
                    </div>
                  </td>
                  <td>
                    <span class="status-badge" [ngClass]="'status-' + project.status">
                      {{ project.status | uppercase }}
                    </span>
                    <span *ngIf="project.revisionRequested" class="rebid-tag" style="margin-top:4px;display:inline-flex;"
                          [title]="project.revisedBudget ? 'Revised budget: ₹' + project.revisedBudget.toLocaleString('en-IN') : 'Budget revised'">
                      <i-tabler name="refresh-alert" style="width:12px;height:12px;flex-shrink:0;"></i-tabler>
                      Re-bid
                    </span>
                  </td>
                  <td>{{ project.bidAmount }}</td>
                  <td>{{ project.timeline }}</td>
                  <td>
                    <div class="progress-cell">
                      <div *ngIf="project.progress !== undefined" class="progress-bar">
                        <div class="progress-fill" [style.width.%]="project.progress"></div>
                      </div>
                      <span class="progress-text">
                        {{ project.progress !== undefined ? project.progress + '%' : '-' }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="cell-with-icon">
                      <span>{{ project.clientRemarks }}</span>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="filteredProjects.length === 0">
                  <td colspan="7" class="no-projects">
                    No projects found matching "{{ searchQuery }}"
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Completed Projects Tab -->
        <div *ngIf="activeTab === 'completed' && visibilityVendor" class="tab-content">
          <div class="projects-grid-container">
            <div class="projects-grid-header">
               <div>Project Details</div>
              <div>Status</div>
              <div>Owner</div>
              <div>Actions</div>
            </div>
            
            <div class="projects-grid-body">
              <div *ngFor="let project of filteredCompletedProjects" class="project-card">
                <div class="grid-cell">
                  <div class="project-details">
                    <div class="project-meta">
                      <span class="date" [style.color]="getDateColor(project.createdDate)">
                         Posted:{{ getFormattedDate(project.createdDate) }}
                      </span>
                      <!-- <span class="customer">- {{ project.customer }}</span>
                      <span class="type">- {{ project.type }}</span> -->
                      <span class="lead">{{ project.lead.toLowerCase().includes('sales') ? 'sales' : project.lead }}</span>
                    </div>
                    <div class="customer">{{ project.customer }}</div>
                    <div class="type">{{ project.type }}</div>
                    <div class="project-title">
                      <span class="title">{{ project.title }}</span>
                      <!-- <span class="vendor-stars">
                        <i *ngFor="let star of [].constructor(getVendorCostStars(project.vendorCost)); let i = index" 
                           class="bi bi-star-fill" style="color: gold; margin: 0 2px"></i>
                      </span> -->
                    </div>
                  </div>
                </div>
                
                <div class="grid-cell">
                  <div class="project-status">
                    <div *ngIf="project.status == 'In Progress'" class="status-icons">
                      <i *ngIf="project.stgplan" title="Waiting for Terms of Engagement to be Accepted." 
                         class="bi bi-bullseye status-icon planning"></i>
                      <i *ngIf="project.stgres" title="Looking for Vendors." 
                         class="bi bi-people status-icon resources"></i>
                      <i *ngIf="project.stgdel" title="Delivering." 
                         class="bi bi-truck status-icon delivery"></i>
                    </div>
                  </div>
                </div>
                
                <div class="grid-cell">
                  <div class="project-owner">
                    {{ project.owner }}
                  </div>
                </div>
                
                <div class="grid-cell">
                  <div class="project-actions">
                    <button class="action-btn" [disabled]="!project.deliveryDate" 
                            [title]="project.deliveryDate ? 'Delivery Information: ' + project.deliveryDate : 'No Delivery Date Available'">
                      <i-tabler name="calendar" [style.color]="project.deliveryDate ? '#ec202a' : '#888888'"></i-tabler>
                    </button>
                    <a href="/workspace/project/{{ project.id }}" target="_blank" class="action-btn-link">
                      <button class="action-btn" title="View {{ project.id }}">
                        <i-tabler name="arrow-up-right" style="color: #ec202a"></i-tabler>
                      </button>
                    </a>
                  </div>
                </div>
              </div>
              
              <div *ngIf="completedProjects.length === 0" class="no-projects-card">
                No completed projects found
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>